/* TAILENTED ALL BETA — CONVERSION BEHAVIOUR */
(function(){
  'use strict';
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-IE',{style:'currency',currency:'EUR'}).format(n);
  const cartUrl='/cart.js';
  async function getCart(){const r=await fetch(cartUrl,{headers:{Accept:'application/json'}});return r.json()}
  function findCartRoot(){return $('.tt-cart-drawer')||$('.cart-drawer')||$('#CartDrawer')||$('cart-drawer')||$('.drawer--cart')}
  function renderProgress(root,cart){
    if(!root||!cart) return;
    const threshold=60, subtotal=(cart.total_price||0)/100, left=Math.max(0,threshold-subtotal), pct=Math.min(100,subtotal/threshold*100);
    let box=$('.tt-cart-progress',root);
    if(!box){box=document.createElement('div');box.className='tt-cart-progress';const target=$('.cart-drawer__inner,.drawer__inner,.cart-drawer__content',root)||root.firstElementChild||root;target.prepend(box)}
    box.innerHTML=left>0?'<div class="tt-cart-progress__text">'+money(left)+' away from FREE delivery</div><div class="tt-cart-progress__bar"><div class="tt-cart-progress__fill" style="width:'+pct+'%"></div></div>':'<div class="tt-cart-progress__text">🎉 You unlocked FREE delivery</div><div class="tt-cart-progress__bar"><div class="tt-cart-progress__fill" style="width:100%"></div></div>';
  }
  async function addVariant(id){
    const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});
    if(!r.ok) throw new Error('Add failed');
    document.dispatchEvent(new CustomEvent('tt:cart-updated'));
    return r.json();
  }
  function bindQuickAdds(){
    $$('form[action="/cart/add"] button[name="add"], .tt-quick-add').forEach(btn=>{
      if(btn.dataset.ttBound) return; btn.dataset.ttBound='1';
      btn.addEventListener('click',()=>{setTimeout(()=>document.dispatchEvent(new CustomEvent('tt:cart-updated')),350)});
    });
  }
  async function addRecommendations(root,productId){
    if(!productId||$('.tt-recommendations')) return;
    try{
      const r=await fetch('/recommendations/products.json?product_id='+encodeURIComponent(productId)+'&limit=4');
      if(!r.ok)return; const data=await r.json(); const products=data.products||[]; if(!products.length)return;
      const wrap=document.createElement('section');wrap.className='tt-recommendations';
      wrap.innerHTML='<div class="tt-recommendations__head"><div><h2 class="tt-recommendations__title">Complete the look</h2><p class="tt-recommendations__sub">Popular picks that pair well with this.</p></div></div><div class="tt-recommendations__grid"></div>';
      const grid=$('.tt-recommendations__grid',wrap);
      products.forEach(p=>{const a=document.createElement('a');a.className='tt-reco-card';a.href='/products/'+p.handle;a.innerHTML='<div class="tt-reco-card__image">'+(p.featured_image?'<img loading="lazy" src="'+p.featured_image+'" alt="">':'')+'</div><div class="tt-reco-card__title"></div><div class="tt-reco-card__price"></div>';$('.tt-reco-card__title',a).textContent=p.title;$('.tt-reco-card__price',a).textContent=money(Number(p.price));grid.appendChild(a)});
      const target=$('.product__info-container,.product-single__meta,.product__media-wrapper')||$('main'); target?.closest('.shopify-section')?.parentElement?.appendChild(wrap)||target?.parentElement?.appendChild(wrap);
    }catch(e){}
  }
  function productId(){
    const el=$('input[name="product-id"]')||$('form[action="/cart/add"] input[name="id"]');
    if(el?.value)return el.value;
    const m=document.querySelector('meta[property="og:url"]'); if(!m)return null;
    const match=m.content.match(/\/products\/([^?]+)/); return match?null:null;
  }
  async function refreshCart(){
    const root=findCartRoot(); if(!root)return;
    try{const cart=await getCart();renderProgress(root,cart)}catch(e){}
  }
  function observeCart(){
    document.addEventListener('tt:cart-updated',()=>setTimeout(refreshCart,150));
    ['click'].forEach(type=>document.addEventListener(type,e=>{
      const t=e.target.closest?.('[data-cart-toggle],[aria-controls*="Cart"],.cart-icon,.header__icon--cart,.tt-cart-trigger');
      if(t)setTimeout(refreshCart,250);
    }));
  }
  document.addEventListener('DOMContentLoaded',()=>{
    bindQuickAdds();observeCart();refreshCart();
    const pid=productId(); if(pid)addRecommendations(document.body,pid);
    const mo=new MutationObserver(()=>bindQuickAdds());mo.observe(document.body,{subtree:true,childList:true});
  });
})();
